import globalMU from "globalMU";
import React, { useEffect, useState } from "react"
import { DadosOrcamentoAlterarValidade } from "./AlterarValidadePedidoContainer";
import { DataFormatoEN } from "app/types/DataFormatoEN";
import { InputData } from "../inputs/InputData";

const estilosBotoes = require("../../estilos/botoes.module.scss").default;

export type AlterarValidadePedidoProps = 
{
    dadosPedido: DadosOrcamentoAlterarValidade
    onAlterarDataValidade: (novaData: DataFormatoEN) => void
    processando: boolean
}

export const AlterarValidadePedido = (props: AlterarValidadePedidoProps) => {
    const [novaData, setNovaData] = useState<DataFormatoEN>(null)

    useEffect(() => {
        const dataAtual = globalMU.converterObjetoDateParaDataFormatoEN(new Date())
        setNovaData(dataAtual)

    }, [])

    
    return (
        <>
            {props.dadosPedido != null &&
                <div className="_my-4">
                    <div className="_flex _items-center">
                        <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Nº Orçamento</label>
                        <p className="_mb-0 _p-2">{props.dadosPedido?.Numero}</p>
                    </div>
                    <div className="_flex _items-center">
                        <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Filial</label>
                        <p className="_mb-0 _p-2">{props.dadosPedido?.Filial}</p>
                    </div>
                    
                    <div className="_flex _items-center">
                        <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Cliente</label>
                        <p className="_mb-0 _p-2">{props.dadosPedido?.NomeCliente}</p>
                    </div>

                    {props.dadosPedido?.NomeCliente !=="CONSUMIDOR FINAL" &&
                        <div className="_flex _items-center">
                            <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">CPF/CNPJ Cliente</label>
                            <p className="_mb-0 _p-2">{props.dadosPedido?.CnpjCPfCliente}</p>
                        </div>
                    }
                    
                    {props.dadosPedido?.NomeCliente !=="CONSUMIDOR FINAL" 
                    && <>
                        <div className="_flex _items-center">
                            <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Rua / Nº</label>
                            <p className="_mb-0 _p-2">{props.dadosPedido?.Logradouro} - {props.dadosPedido?.NumeroEndereco}</p>
                        </div>
                        {props.dadosPedido?.ComplementoEndereco !== ""
                        &&
                            <div className="_flex _items-center">
                                <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Complemento</label>
                                <p className="_mb-0 _p-2">{props.dadosPedido?.ComplementoEndereco}</p>
                            </div>
                        }
                        <div className="_flex _items-center">
                            <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Bairro</label>
                            <p className="_mb-0 _p-2">{props.dadosPedido?.Bairro}</p>
                        </div>
                        </>
                    }
            
                    <div className="_flex _items-center">
                        <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Cidade / UF</label>
                        <p className="_mb-0 _p-2">{props.dadosPedido?.Cidade} / {props.dadosPedido?.UF}</p>
                    </div>
                    {props.dadosPedido?.NomeCliente !=="CONSUMIDOR FINAL" 
                    && <>
                        <div className="_flex _items-center">
                            <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">CEP</label>
                            <p className="_mb-0 _p-2">{props.dadosPedido?.Cep}</p>
                        </div>
                        <div className="_flex _items-center">
                            <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Telefone</label>
                            <p className="_mb-0 _p-2">{props.dadosPedido?.Telefone}</p>
                        </div>
                        </>
                    }
                    <div className="_flex _items-center">
                        <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Forma de Pagamento</label>
                        <p className="_mb-0 _p-2">{props.dadosPedido?.FormaDePagamento}</p>
                    </div>
                    <div className="_flex _items-center">
                        <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Tipo de Documento</label>
                        <p className="_mb-0 _p-2">{props.dadosPedido?.TipoDeDocumento}</p>
                    </div>

                    <div className="_flex _items-center">
                        <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2 ">Desconto</label>

                        <p className="_mb-0 _p-2">{
                            globalMU.formatarValorNumerico(props.dadosPedido?.ValorDesconto, 2, true)}
                        </p>
                    </div>

                    <div className="_flex _items-center">
                        <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-bold _mb-0 _p-2 ">Total</label>

                        <p className="_mb-0 _p-2 _font-bold">{
                            globalMU.formatarValorNumerico(props.dadosPedido?.ValorPedido, 2, true)}
                        </p>
                    </div>

                    <div className="_flex _items-center">
                        <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Validade Atual</label>
                        <p className="_mb-0 _p-2">{globalMU.formatJsonDate(props.dadosPedido?.Validade)}</p>
                    </div>

                    <div className="_flex _items-center">
                        <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _p-2">Nova Validade</label>
                        <InputData 
                            id="AlterarValidadePedido_NovaValidadeInput"
                            disabled={props.processando}
                            data={globalMU.converterDataHoraFormatoENComTParaDataFormatoPT(novaData)}
                            bloquearDataMenorQueHoje={true}
                            onChange={e => {setNovaData(e)}}
                            selecionaValorOnFocus={true}
                        />
                    </div>

                   
                    <div className="_flex _items-center">
                        <label className="_w-[190px] _bg-[#e4e6e8] _text-right _font-normal _mb-0 _px-2 _py-6" />
                        <button 
                            className={`_flex no-global-button _mx-2 _mt-2 ${estilosBotoes.botaoPrimario}`}
                            disabled={props.processando}
                            id="AlterarValidadePedido_SalvarButton"
                            onClick={() => 
                                {
                                    if (novaData == null)
                                    {
                                        globalMU.showErrorMessage("Informe a nova data de validade.")
                                        return
                                    }
                                    props.onAlterarDataValidade(novaData)
                                }
                            }
                        >
                            Alterar Data de Validade
                        </button>
                    </div>

                    <section style={{ marginBottom: "100px" }} />
                </div>
                
            }
        </>
    )
}